/* eslint-disable @typescript-eslint/no-explicit-any */
import { AbstractControl, ValidatorFn } from '@angular/forms';

export function haveLeastOneFieldFilled(fields: string[]): ValidatorFn {
  return (
    control: AbstractControl<string>
  ): { haveLeastOneFieldFilled: boolean } | null => {
    const controls = fields
      .map(field => control.get(field))
      .filter(Boolean) as AbstractControl[];
    return controls.length
      ? controls.every(control => !control.value)
        ? { haveLeastOneFieldFilled: true }
        : null
      : null;
  };
}
